export default "__VITE_ASSET__DS13i_W0__"